import { Navigate } from 'react-router-dom'
import { ROUTES } from '@utils/constants.js'

/** Checklist global fundido na Jornada (aba Progresso). */
export function ChecklistPage() {
  return <Navigate to={`${ROUTES.MODULOS}?vista=progresso`} replace />
}
